import axios from 'axios';
import { GOFAR_SERVICE_URL } from './config';

const gofarService = async (url, method, data) => {
  const fullUrl = `${GOFAR_SERVICE_URL}${url}`;
  try {
    const result = await axios({
      method,
      url: fullUrl,
      data
    });
    return result;
  } catch (err) {
    return err.response;
  }
};
export { gofarService };
